import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, useLocation } from 'react-router-dom'

import SsoFeaturebaseRedirect from '../components/external_sso/SsoFeaturebaseRedirect'
import SsoMetabaseRedirect from '../components/external_sso/SsoMetabaseRedirect'
import LoadingSpinner from '../components/general/LoadingSpinner'
import SSoSignInPage from '../components/sessions/SSoSignInPage'
import MFRouterRR7 from './MFRouterRR7'
import ProtectedApp from './ProtectedApp'
import { shouldUseRR7 } from './rr7AllowList'
import SessionsRoutes from './SessionsRoutes'

export default function MFRouter() {
  /** @type {import('../reducers/adminsReducer.js').CurrentAdmin} */
  const currentAdmin = useSelector(state => state.admins.current_admin)
  /** @type {import('../redux/storeConfig/slices/slice.auth/auth.types').AuthSlice}*/
  const auth = useSelector(state => state.auth)

  const location = useLocation()
  const useRR7 = shouldUseRR7(location.pathname)

  const isLoggedIn = useMemo(
    () => !!(auth.isAuthenticated && currentAdmin?.id),
    [auth.isAuthenticated, currentAdmin?.id]
  )

  const loggedInAsContext = useMemo(() => {
    switch (currentAdmin?.logged_in_as) {
      case 'Agency':
        return 'Agency'
      case 'Organization':
        return 'Organization'
      default:
        return null
    }
  }, [currentAdmin?.logged_in_as])

  if (!auth.isInitialized) return <LoadingSpinner />

  // Use complete React Router 6 for migrated routes
  if (useRR7) {
    return <MFRouterRR7 />
  }

  return (
    <Switch>
      <Route path="/sso-log-in/:sso_id/:sso_token" component={SSoSignInPage} />
      <Route path="/sso/external/featurebase" component={SsoFeaturebaseRedirect} />
      <Route path="/sso/external/metabase" component={SsoMetabaseRedirect} />

      <Route exact path={['/login', '/forgot_password', '/reset_password/:token', '/auth0_callback']}>
        <SessionsRoutes isLoggedIn={isLoggedIn} />
      </Route>

      <Route path="/">
        <ProtectedApp isLoggedIn={isLoggedIn} loggedInAsContext={loggedInAsContext} />
      </Route>
    </Switch>
  )
}
